import { useState, useEffect } from 'react';

export default function AlertComponent({ message, duration = 3000 }) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
        }, duration);
        return () => clearTimeout(timer);
    }, [duration]);

    return (
        <div className={`fixed inset-0 z-[70] flex items-center justify-center bg-black/50 backdrop-blur-sm ${visible ? 'opacity-100' : 'pointer-events-none opacity-0'} transition-opacity duration-500`}>
            <div className={`transform rounded-2xl border border-zinc-600 bg-gradient-to-b from-zinc-800 to-zinc-950 p-5 text-zinc-100 shadow-2xl shadow-black ${visible ? 'translate-y-0' : '-translate-y-full'} transition-transform duration-500`}>
                {message}
            </div>
        </div>
    );
}
